<div
  class="modal fade"
  id="delConfirmModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="delConfirmModal"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ "Confermare eliminazione" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{
          "Continuare con l'operazione? Ricordiamo che i dati eliminati non si potranno recuperare"
            | translate
        }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ "Annulla" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          data-dismiss="modal"
          (click)="deleteVendor(vendorToDelete)"
        >
          {{ "Conferma" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="evalModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="evalModalLabel"
  aria-hidden="true"
>
   <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ "Inserisci Valutazione per" | translate }} {{evaluation ? evaluation.account : ''}}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          #closeButton
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body body-category-root">
        <form>
          <div
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            "
          >
            <div class="form-group" style="width: 49%">
              <label for="evalrate">{{ "Valutazione" | translate }}</label>
              <input
                [(ngModel)]="evaluation.rate"
                type="number"
                min="0" max="10"
                class="form-control"
                id="evalrate"
                name="evalrate"
                placeholder="Inserisci la valutazione da 0 a 10"
                (input)="checkEvaluationRate()"
              />
            </div>

            <div class="form-group" style="width: 49%">
              <label for="evaldate">{{ "Data" | translate }}</label>
              <input
                [(ngModel)]="evaluation.date"
                type="date"
                class="form-control"
                id="evaldate"
                name="evaldate"
                placeholder="Inserisci la data dd/MM/yyyy"
              />
            </div>
          </div>

          <div class="form-group">
            <label for="evaldesc">{{ "Descrizione" | translate }}</label>
            <br />
            <small>{{
              "Inserisci il testo che apparirà nella valutazione" | translate
            }}</small>
            <editor
              name="evaldesc"
              apiKey="1sdv0g430kwfa3fbpe8x98vr7eyu3x9il416pnmm3mjo3s52"
              cloudChannel="8"
              [init]="{
                font_formats: 'Barlow=Barlow; Roboto=Roboto; Barlow Condensed=Barlow-condensed; Gilda Display=Gilda-display; Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MSX=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva',
                plugins: 'lists link quote hr underline align strikethrough emoticons',
                images_file_types: '',
                block_unsupported_drop: true
              }"
              [(ngModel)]="evaluation.description"
              (onInit)="onInitEditor()"
            ></editor>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          (click)="cancelEditEvaluation()"
        >
          {{ "Annulla" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="disableSaveButton"
          (click)="saveEvaluation()"
        >
          {{ "Salva" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="row mx-0">
  <div class="col-12 my-2">
    <div class="row mx-0 w-100">
        <div class="col-12 p-0">
            <span>{{ "Amministrazione" | translate }}</span>
            <h3 class="color-theme font-weight-bold">
            {{ "Elenco fornitori" | translate }}
            </h3>
        </div>
    </div>
    <div class="row mx-0 w-100">
      <div class="form-group col-1 p-0">
        <div>
          <label for="search">{{ "Cerca" | translate }}:</label>
          <input id="search" [(ngModel)]="searchValue" />
        </div>
        <div>
          <label for="searchType">{{ "Tipo" | translate }}:</label>
          <br/>
          <select id="searchType" [(ngModel)]="searchSelect">
            <option value="">{{ "Tutti" | translate }}</option>
            <option value="active">{{ "Attivi" | translate }} ({{counterActive}})</option>
            <option value="pending">{{ "In Attesa (Tipo)" | translate }} ({{counterPending}})</option>
            <option value="demo">{{ "Demo" | translate }} ({{counterDemo}})</option>
          </select>
        </div>
      </div>

      <div class="col-7 col-sm-7 col-ml-7 col-xl-9"></div>

      <div class="col-4 col-sm-4 col-ml-4 col-xl-2 p-0">
        <button class="btn btn-primary mb-4 w-100" routerLink="/register">
          + {{ "Aggiungi Fornitore" | translate }}
        </button>
      </div>
    </div>

    <div class="row mx-0">
      <div class="card w-100">
        <div class="card-body" style="overflow-y: auto">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Account</th>
                <th scope="col">Email</th>
                <th scope="col">{{ "Tipo" | translate }}</th>
                <th scope="col">{{ "Valutazione" | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let vendor of vendorList | filter: searchValue | filter: searchSelect"
                style="cursor: pointer"
              >
                <td
                  style="
                    border-left: 1px solid rgba(0, 0, 0, 0.125);
                    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
                    width: 30%;
                  "
                  (click)="impersonate(vendor.account)"
                >
                  {{ vendor.account }}
                </td>
                <td
                  style="
                    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
                    width: 30%;
                  "
                  (click)="impersonate(vendor.account)"
                >
                  {{ vendor.email }}
                </td>
                <td
                  style="
                    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
                    width: 15%;
                  "
                  class="paddingVendorType"
                >
                  <!-- (click)="impersonate(vendor.account)"-->
                  <div *ngIf="vendor.role != 'Manager'">
                    <span style="display: none">{{ vendor.type }}</span>
                    <span style="cursor: pointer;" (click)="changeVendorType(vendor, 'active')"
                        [matTooltip]="'Attivo' | translate">
                        <img class="permissions mx-2"
                            src="assets/img/icona_user.png"
                            style="width: 30px"
                            [ngStyle]="vendor.type != 'active' && {'filter': 'drop-shadow(0 100000px 0 rgb(91, 91, 91))'}"
                        />
                    </span>
                    <span style="cursor: pointer;" (click)="changeVendorType(vendor, 'pending')"
                        [matTooltip]="'In Attesa (Tipo)' | translate">
                        <img class="permissions mx-2"
                            src="assets/img/icona_clock.png"
                            style="width: 30px"
                            [ngStyle]="vendor.type != 'pending' && {'filter': 'drop-shadow(0 100000px 0 rgb(91, 91, 91))'}"
                        />
                    </span>
                    <span style="cursor: pointer;" (click)="changeVendorType(vendor, 'demo')"
                        [matTooltip]="'Demo' | translate">
                        <img class="permissions mx-2"
                            src="assets/img/icona_demo.png"
                            style="width: 30px"
                            [ngStyle]="vendor.type != 'demo' && {'filter': 'drop-shadow(0 100000px 0 rgb(91, 91, 91))'}"
                        />
                    </span>
                  </div>
                </td>
                <td
                  style="
                    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
                    width: 20%;
                  "
                >
                  <div *ngIf="vendor.evalrate">
                    <span>{{ vendor.evalrate }} / 10, {{ "in data" | translate }} {{vendor.evaldate | date: 'dd/MM/yyyy'}}</span>
                  </div>
                </td>
                <td
                  style="
                    border-right: 1px solid rgba(0, 0, 0, 0.125);
                    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
                    padding: 0;
                    width: 10%;
                  "
                >
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: flex-end;
                      width: 100%;
                    "
                  >
                    <div
                      data-toggle="modal"
                      data-target="#evalModal"
                      class="modifyImg"
                      (click)="setAccountEvaluationData(vendor)"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" fill="white" class="bi bi-building-check" viewBox="0 0 16 16">
                        <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514"/>
                        <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3v-2.5a.5.5 0 0 1 .5-.5H8v4H3a1 1 0 0 1-1-1z"/>
                        <path d="M4.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-6 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm3 0a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/>
                      </svg>
                    </div>
                    <div class="modifyImg" (click)="infoVendor(vendor.account)">
                      <svg
                        class="bi bi-info-circle"
                        width="30px"
                        height="30px"
                        viewBox="0 0 16 16"
                        fill="white"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
                        />
                        <path
                          d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588z"
                        />
                        <circle cx="8" cy="4.5" r="1" />
                      </svg>
                    </div>
                    <div
                      data-toggle="modal"
                      data-target="#delConfirmModal"
                      class="deleteImg"
                      (click)="vendorToDelete = vendor.account"
                    >
                      <img
                        src="assets/img/Pittogramma elimina - cestino.png"
                        style="width: 30px"
                        alt=""
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
